import { inject, injectable } from 'inversify'
import { RequestHandler, requestHandler } from 'mediatr-ts'

import { SessionManager } from '@infrastructure/managers/session/session-manager'

import { SignOutCommand } from './command'

@requestHandler(SignOutCommand)
@injectable()
export class SignOutCommandHandler implements RequestHandler<SignOutCommand, void> {
  constructor(@inject(SessionManager) private readonly sessionManager: SessionManager) {}

  public handle(): Promise<void> {
    this.sessionManager.signOut()
    return Promise.resolve()
  }
}
